import { withStyles } from '@material-ui/core/styles'
import styles from './CoreLayout.styles'

export default withStyles(styles)
